{
  "admin": {
    "fast-forward": "快进",
    "no-segment-pause": "不要在视频片段处暂停",
    "show-correct-answers": "显示正确答案",
    "title": "测试模式",
    "transfer-to-new-device": "转移到其他设备",
    "video-stats": "视频统计"
  },
  "android-app": {
    "download-button": "从 Google Play 下载",
    "footer-note": "找不到在哪里输入代码？打开应用后，您会看到“员工登录”界面。",
    "heading": "安装应用并使用您的代码登录",
    "how-to-start": "如何开始：",
    "intro": "您将获得：",
    "notifications-desc": "接收实时通知，无需手动检查应用。",
    "notifications-title": "即时通知（推送通知）",
    "scanner-desc": "智能相机会自动识别文档边界、校正透视，并优化光线，以提高文本可读性。",
    "scanner-title": "高级文档扫描仪",
    "step1": "下载应用：",
    "step2": "打开它",
    "step3": "输入以下代码：",
    "title": "Android 应用"
  },
  "broadcast": {
    "from": "由<Name/>在<SentAt/>发送",
    "mark-as-read": "已读",
    "mark-as-read-confirm": {
      "title": "签名确认您已阅读并理解此消息"
    },
    "read-at": "<Name/>于<ReadAt/>已读"
  },
  "control-card": {
    "action": {
      "complete": "完成控制卡",
      "print": "打印",
      "signature": "签名",
      "title": "此控制卡的操作",
      "uncomplete": "解锁控制卡",
      "view-print": "查看/打印"
    },
    "add-new-record-title": "{{title}}：添加新记录",
    "breadcrumbs": {
      "row": "记录{{current}}共{{total}}"
    },
    "comment": "评论",
    "complete-alert": {
      "confirm": "完成",
      "message": "要完成控制卡，必须填写所有记录。",
      "title_other": "有{{count}}个记录未填写"
    },
    "complete-error": {
      "message_other": "有{{count}}个记录未填写",
      "title": "无法完成控制卡"
    },
    "due-to": "截止时间：<Time/><RelTime/>",
    "error": {
      "saving-error": "保存数据时出错：{{message}}。要重试，请按“保存”按钮"
    },
    "instantiate": {
      "confirmation-message": "您确定要创建控制卡“{{name}}”吗？",
      "header": "新建控制卡“{{name}}”",
      "message": "您必须选择以下选项之一：",
      "option-create-copy": "转移此控制卡的数据",
      "option-create-empty": "新的空白控制卡"
    },
    "location": {
      "archived-title": "已存档的控制卡",
      "create-new": "创建",
      "date": "日期",
      "edit-disabled-banner": "由于过期或无权填写，卡无法编辑",
      "label": "对象",
      "no-control-cards": "未找到控制卡",
      "not-applicable": {
        "header": "不适用",
        "message": "此控制卡由{{notApplicableBy}}标记为不适用，原因：{{notApplicableReason}}"
      },
      "recurring": {
        "create": {
          "date": "日期",
          "no-permission": "您无权为此日期创建控制卡",
          "template": "选择新卡",
          "title": "新定期控制卡"
        },
        "filter": {
          "endDate": "结束日期",
          "label": "筛选",
          "startDate": "开始日期",
          "status": "状态",
          "statuses": {
            "all": "已完成和未完成",
            "complete": "仅已完成",
            "incomplete": "仅未完成"
          },
          "subtitle": "按以下条件筛选控制卡：",
          "template": "类型",
          "text": "名称",
          "textPlaceholder": "无所谓",
          "title": "筛选控制卡"
        },
        "load-more": "加载早于<StartDate/>的记录"
      },
      "title": "待填写的控制卡"
    },
    "nested": {
      "create": "创建",
      "creating": "创建中...",
      "open": "打开",
      "status": {
        "completed": "已完成",
        "not-applicable": "不适用",
        "pending": "未完成"
      }
    },
    "no-locations": "您没有权限访问任何场所的控制卡",
    "number-range": {
      "max-exceeded": "最大允许值为{{maxValue}}",
      "min-exceeded": "最小允许值为{{minValue}}",
      "no-unit": {
        "closed": "{{start}} – {{end}}",
        "open-end": "大于{{start}}",
        "open-start": "小于{{end}}"
      },
      "text": "范围",
      "unit": {
        "closed": "{{start}} – {{end}} {{unit}}",
        "open-end": "大于{{start}} {{unit}}",
        "open-start": "小于{{end}} {{unit}}"
      }
    },
    "override-validation-result": {
      "mark-not-applicable": "标记为不适用",
      "option": {
        "not-applicable": "不适用",
        "other": "其他",
        "other-placeholder": "填写原因"
      },
      "reason-option-required": "必须选择以下选项之一：",
      "title": "标记无法填写此字段的原因："
    },
    "primary-column-title_other": "在此控制卡中有{{count}}个“{{title}}”记录",
    "row": {
      "action": {
        "complete": "完成",
        "complete-error": {
          "message_other": "有{{count}}个记录未填写",
          "title": "无法完成控制卡"
        },
        "complete-success-last-record": "控制卡已完全填写",
        "confirm-delete": {
          "title_other": "确定要删除这{{count}}个记录吗？",
          "title-name": "删除“{{name}}”？"
        },
        "confirm-remove-signature": {
          "title": "确定要移除此签名吗？"
        },
        "delete": "删除",
        "more-info": "更多信息",
        "title": "此记录的操作",
        "uncomplete": "解锁"
      },
      "completed-by": "完成人",
      "more-info": {
        "title": "此记录的信息"
      }
    },
    "status": {
      "completed": "由<Name/>完成",
      "not-applicable": "不适用 ({{notApplicableBy}}标记原因：{{notApplicableReason}})",
      "not-completed": "未完成"
    },
    "title": "控制卡",
    "type": {
      "daily": "每日",
      "recurring": "定期"
    },
    "value": {
      "empty": "无值",
      "invalid": "数据无效！"
    }
  },
  "error": {
    "playback": {
      "header": "播放错误",
      "message": "请重新加载页面并重试。",
      "reload-button": "重新加载"
    },
    "unexpected": {
      "header": "错误",
      "message": "请重新加载应用。",
      "reload-button": "重新加载"
    }
  },
  "g": {
    "action": "操作",
    "add": "添加",
    "all": "全部",
    "app-name": "FSAcademy.bg",
    "attachment": {
      "delete-confirmation": {
        "title": "您确定要删除这张照片吗？"
      }
    },
    "back": "返回",
    "back-to-home": "主页",
    "cancel": "取消",
    "change": "更改",
    "clear": "清除",
    "close": "关闭",
    "combo-box": {
      "add-header": "添加选项",
      "delete-title": "确定要删除此选项吗？",
      "edit-header": "编辑选项",
      "placeholder": "输入或从列表中选择"
    },
    "complete": "完成",
    "continue_zero": "继续",
    "continue_other": "继续 ({{count}})",
    "copyright-and-privacy-policy": "© 2026 Ef Es Academy Ltd. ⋅ <2>隐私政策</2>",
    "delete": "删除",
    "discard": "放弃",
    "doc-file-name": "文件名",
    "doc-file-size": "大小",
    "edit": "编辑",
    "error": {
      "disabled-error": "您的账户已被禁用。请联系管理员",
      "network-error": "暂时无法连接到服务器。请检查您的互联网连接并重试",
      "not-available-error": "资源不可用或您无权访问。",
      "server-error": "服务器错误。请稍后再试"
    },
    "feature-disabled": "此服务未对您的公司激活",
    "filter": "应用过滤器",
    "filter-button_zero": "过滤器",
    "filter-button_other": "过滤器 ({{count}})",
    "later": "稍后",
    "loading": "加载中，请稍候...",
    "loading-error": "发生错误，请在几秒钟后重新加载页面",
    "ok": "确定",
    "page-not-found": "页面未找到",
    "pagination": {
      "page": "{{pageCount}}页中的第{{pageNumber}}页"
    },
    "privacy-policy-url": "/legal/privacy-policy/latest-en",
    "remove": "移除",
    "required": "必填",
    "save": "保存",
    "search-employee-name-or-position": "按姓名或职位搜索",
    "select-date": "选择日期",
    "select-employee": "选择员工",
    "select-time": "选择时间",
    "select-value": "选择",
    "share": {
      "button": "分享",
      "download": {
        "downloading": "下载中，请稍候...",
        "error": {
          "message": "下载文件时出错。请重试。",
          "title": "下载文件时出错"
        }
      },
      "error": {
        "generic": "您的浏览器不支持此文件分享方式。请尝试其他选项。",
        "title": "分享错误"
      },
      "pdf-file-attach": "分享PDF",
      "pdf-file-download": "下载PDF",
      "title": "分享文档{{name}}"
    },
    "upload": "上传",
    "upload-more": "上传更多",
    "uploaded-files_other": "上传的文件：{{count}}",
    "uploading": "上传中（{{uploadProgress}}）",
    "user-disable": {
      "action": "以其他员工身份登录",
      "title": "您的访问已被禁用"
    },
    "yes": "是"
  },
  "help": {
    "email-action": "{{email}}",
    "email-title": "通过电子邮件联系我们：",
    "manual-action": "打开手册",
    "manual-title": "查看用户手册：",
    "p1": "如果您在使用应用程序时遇到困难，您可以通过以下方式获得帮助：",
    "phone-action": "{{phone}}",
    "phone-title": "拨打电话联系我们：",
    "title": "帮助",
    "viber-action": "通过Viber聊天",
    "viber-title": "通过Viber给我们发送消息：",
    "work-hours": "我们将在工作日的9点到17点回复您"
  },
  "incdoc": {
    "action": {
      "confirm-delete": {
        "title": "您确定要删除此文档吗？"
      },
      "delete": "删除",
      "edit": "编辑",
      "scan-result": "查看识别出的文档",
      "title": "操作"
    },
    "add-doc": "新建文档",
    "doc": {
      "add-document-success": "文档添加成功",
      "add-document-title": "添加文档",
      "ai-apply-button": "填写所选项",
      "ai-create-new": "创建新的",
      "ai-dialog-title": "请将识别出的属性与文档核对",
      "ai-existing": "已有",
      "ai-fill-button": "开始",
      "ai-fill-label": "使用 AI 填写",
      "ai-new": "新建",
      "ai-no-results": "我们无法从文档中识别出数据。请拍摄更清晰的照片——确保光线充足，并且整个文档都在画面中。",
      "ai-no-results-label": "AI 未识别到数据",
      "ai-suggestions-button": "查看",
      "ai-suggestions-label": "我们已使用 AI 识别该文档",
      "ai-use-existing": "使用已有",
      "doc-date": "文档日期",
      "doc-num": "文档编号",
      "doc-num-placeholder": "请输入文档编号",
      "edit-document-title": "编辑文档",
      "location": "对象",
      "notes": "备注",
      "notes-placeholder": "附加备注（如需要）",
      "supplier": "供应商",
      "update-document-success": "文档编辑成功"
    },
    "doc-no": "文档编号 {{docNum}}",
    "doc-subtitle": "日期 <2><0></0></2>，供应商 <4>{{supplierName}}</4>，对象 <6>{{locationName}}</6>，由 <9>{{creatorName}}</9> 创建于 <11><0></0></11>",
    "filter": {
      "created-date-after": "创建日期之后",
      "created-date-before": "创建日期之前",
      "doc-date-after": "文档日期之后",
      "doc-date-before": "文档日期之前",
      "keyword": "搜索",
      "keyword-placeholder": "文档编号、供应商等",
      "order": "排序",
      "order-by": {
        "created-at": "创建日期",
        "document-date": "文档日期"
      },
      "title": "文档过滤"
    },
    "no-documents": "未找到文档",
    "pagination-count": "{{itemCount}} 个文档",
    "purchase-doc": {
      "actions-title": "操作",
      "export-excel": "导出为 Excel",
      "invoice-number": "文档编号 {{num}}",
      "preview-title": "识别预览"
    },
    "supplier": {
      "add-supplier-error": "添加供应商时出错",
      "add-supplier-success": "成功添加供应商",
      "add-title": "添加供应商",
      "edit-supplier-error": "修改供应商时出错",
      "edit-supplier-success": "成功修改供应商",
      "edit-title": "编辑供应商",
      "eik": "EIK",
      "eik-placeholder": "请输入供应商EIK",
      "name": "名称",
      "name-placeholder": "请输入供应商名称",
      "notes": "备注",
      "notes-placeholder": "附加备注（如需要）"
    },
    "title": "入场控制",
    "upload": {
      "error": "上传错误",
      "finished": "已上传",
      "pending": "等待中",
      "uploading": "上传中"
    }
  },
  "login": {
    "employee-login": "员工登录",
    "enter-your-access-code": "请输入您的访问代码",
    "failed": "登录失败。请检查您的访问代码是否正确",
    "login-button": "登录",
    "no-access-code": "我没有访问代码",
    "privacy-policy": "点击“登录”即表示您同意<2>隐私政策</2>。",
    "success": "登录成功！",
    "welcome": "欢迎来到FSAcademy！"
  },
  "menu": {
    "android-app": "Android 应用",
    "control-card": "控制卡",
    "course": "培训",
    "help": "帮助",
    "incoming-control": "入场控制",
    "language": "语言",
    "logged-out": {
      "already-part-of-team": "您已经是团队成员了吗？",
      "contact-admin-for-code": "请联系您的主管获取访问代码。",
      "contact-us-to": "联系我们以便：",
      "email": "电子邮件",
      "fully-digitize": "<0>全面数字化</0>食品安全控制。",
      "get-demo": "获得平台的<1>简短演示</1>。",
      "get-to-know-services": "<1>了解</1>我们的数字化服务。",
      "phone": "电话",
      "want-to-digitize-question": "想要将您的食品安全管理数字化吗？"
    },
    "logout": "退出",
    "new-badge": "新",
    "notifications": "通知",
    "organizer": "组织者",
    "test-mode": "测试模式",
    "tickets": "工单"
  },
  "notifications": {
    "marked-all-as-read": "所有通知已标记为已读",
    "native": {
      "enable-notifications": "设备通知",
      "permission-hint": "要接收通知，您需要授予权限",
      "title": "通知设置"
    },
    "no-notifications": "您没有通知",
    "read-at": "已读于<ReadAtTime/>",
    "title_zero": "通知",
    "title_other": "通知 ({{count}})",
    "unread-alert": {
      "header_other": "您有{{count}}个未读通知",
      "message_other": "想现在查看吗？"
    }
  },
  "organizer": {
    "action": {
      "confirm-delete": {
        "title": "删除{{name}}？"
      },
      "edit": "编辑"
    },
    "add-document-title": "添加文件",
    "edit-document-title": "编辑文件",
    "folder": {
      "add-new-document": "新文件",
      "add-title": "添加文件夹",
      "confirm-delete": {
        "message": "该文件夹中的所有文件将被删除！",
        "title": "删除{{name}}？"
      },
      "edit": "编辑",
      "edit-title": "编辑文件夹",
      "name": "名称",
      "name-placeholder": "输入文件夹名称",
      "title": "文件"
    },
    "folder-list": {
      "add": "新文件夹",
      "title": "文件夹"
    },
    "form": {
      "folder": "文件夹",
      "name": "名称",
      "name-placeholder": "文件名称，例如许可证...",
      "notes": "备注",
      "notes-placeholder": "附加备注（如需要）",
      "notify-before-expiry": "发送我提醒",
      "notify-before-expiry-hint-1": "我们将在文件到期前发送警示通知。",
      "notify-before-expiry-hint-2": "选择“到期日”以添加提醒。",
      "notify-before-expiry-placeholder": "无提醒",
      "notify-before-expiry-unit": "天前",
      "state": "状态",
      "valid-from": "签发日期",
      "valid-from-hint": "如果没有签发日期，请勿填写",
      "valid-until": "到期日",
      "valid-until-hint": "如果没有期限，请勿填写",
      "valid-until-quick-hint": "快速期限",
      "valid-until-quick-hint-1-month": "1个月",
      "valid-until-quick-hint-1-year": "1年",
      "valid-until-quick-hint-2-years": "2年",
      "valid-until-quick-hint-3-months": "3个月",
      "valid-until-quick-hint-6-months": "6个月"
    },
    "location": "对象",
    "never-expires": "没有期限",
    "no-locations": "您没有访问任何对象的权限",
    "no-reminder-label": "没有提醒",
    "notify-before-expiry-label": "提前<ReminderDuration/>提醒",
    "state": {
      "complete": "已完成",
      "pending": "待定"
    },
    "title": "组织者",
    "valid-from": "有效期自<2><0></0></2>起<4></4>",
    "valid-from-until": "有效期从<2><0></0></2>到<6><0></0></6>",
    "valid-until": "有效期至<2><0></0></2>",
    "validity": {
      "expired": "已过期",
      "expires-soon": "即将过期"
    }
  },
  "player": {
    "lesson-duration": "{{minutes}}分钟",
    "modal": {
      "again": {
        "header": "主题结束",
        "sub-header": "请选择以下选项之一：",
        "watch-again": "重新观看"
      },
      "current": {
        "continue-button": "继续",
        "continue-header": "要继续，请点击“继续”",
        "ended-header": "您已完成该主题",
        "go-to-test": "前往测试"
      },
      "segment": {
        "back-to-home": "返回主页",
        "back-to-results": "返回结果",
        "header": "该片段包含问题的答案",
        "sub-header": "请选择以下选项之一",
        "watch-again": "重新观看"
      }
    },
    "remaining-time-minutes": "剩余{{minutes}}分钟。",
    "remaining-time-seconds": "剩余{{seconds}}秒。",
    "watch-lesson": "观看主题"
  },
  "purchase-doc": {
    "field": {
      "address": "地址",
      "eik": "EIK",
      "expiration-date": "有效期",
      "item-number": "代码",
      "lot-number": "批次",
      "mol": "MOL",
      "name": "名称",
      "quantity": "数量",
      "total-price": "金额",
      "unit": "单位",
      "unit-price": "单价"
    },
    "party": {
      "buyer": "买方",
      "supplier": "卖方"
    },
    "products": "产品",
    "totals": {
      "base": "基数",
      "total": "合计",
      "vat": "增值税"
    }
  },
  "syllabus": {
    "completed": {
      "completed-at": "完成于<2><0></0></2>，平均分<5>{{scorePercent}}</5>",
      "completed-course": "恭喜成功完成培训！",
      "no-completed": "没有已完成的培训",
      "no-such-topic": "没有这样的已通过课程",
      "sign-button": "签署",
      "sign-button-again": "重新签署",
      "title": "已完成的培训"
    },
    "in-progress": {
      "course-progress": "已完成{{completedLessonsCount}}个主题，共{{totalLessonsCount}}个（{{progressPercent}}），平均分{{averageScorePercent}}",
      "current-test-progress": "当前测试成绩{{currentScorePercent}}，最低要求{{minScorePercent}}。",
      "days-remaining": "距离截止日期还有{{days}}天",
      "from-induction-course": "来自入门课程",
      "from-refresh-course": "来自刷新课程",
      "induction-course": "入门",
      "last-answered-at": "最后一次回答是在<1></1>",
      "no-in-progress-topic": "没有进行中的主题",
      "overdue": "已超期{{days}}天！",
      "refresh-course": "复习课程",
      "test-progress": "测试未提交。回答了{{totalEmployeeAnswers}}个问题，共{{totalCorrectAnswers}}个问题。",
      "there-is-important-question": "有错误的必答题",
      "title": "当前主题"
    },
    "pending": {
      "locked": "尚不可用。您有未完成的当前主题",
      "no-pending-course": "没有待处理的培训",
      "title": "待处理的培训"
    },
    "term-signature": {
      "title": "签名确认您已完成此培训"
    },
    "topic": {
      "completed-at": "完成于<1></1>，成绩{{scorePercent}}。",
      "started-at": "开始于<1></1>。"
    }
  },
  "test": {
    "cant-view-test": "完成当前主题后才能访问测试",
    "cant-view-test-result": "完成当前主题后才能查看测试结果",
    "check-the-answer-in-segment": "查看主题片段中的答案",
    "complete-test": "提交测试",
    "congrats": "恭喜！",
    "continue-to-next": "继续下一个主题",
    "correct-answer": "正确答案",
    "failed-answers-paragraph": "以下问题您有{{questionsCount}}个错误答案：",
    "next-question": "下一题",
    "no-answer": "没有答案",
    "no-test-message": "此主题没有测试",
    "not-sufficient-title": "这不足以进入下一个主题。",
    "prev-question": "上一题",
    "question-no": "问题编号 {{questionNo}}",
    "refresh-the-answer-in-segment": "在主题片段中重温答案",
    "result-title": "测试结果",
    "success-rate": "您已成功完成测试，正确率为{{currentScorePercent}}%",
    "take-test": "开始测试",
    "take-test-again": "重做错误的问题",
    "take-test-again-hint": "要重新测试，您需要观看所有错误答案的问题片段。",
    "title": "当前主题的测试",
    "view-results": "查看测试结果",
    "wrong-questions-title": "您有{{questionsCount}}个错误答案，以下为正确答案：",
    "your-answer": "您的答案",
    "your-result-is": "您的结果是{{currentScorePercent}}%"
  },
  "ticket": {
    "action": {
      "accept": "接受",
      "done": "完成",
      "print": "打印",
      "todo": "待处理"
    },
    "add": {
      "content": "描述",
      "content-placeholder": "添加有助于解决该工单的详细信息",
      "group-employees": "员工",
      "group-managers": "管理人员",
      "location": "适用于对象",
      "location-placeholder": "如适用，请说明该工单适用于哪些对象",
      "recipients-label": "接收人",
      "recipients-required": "请选择至少一位接收人",
      "recipients-search-placeholder": "按姓名、职位或对象搜索",
      "subject": "主题",
      "subject-placeholder": "该工单涉及什么",
      "submit": "创建",
      "title": "新工单"
    },
    "change-status": "更改状态",
    "create-from-cc": "提交工单",
    "delete": {
      "confirm-message": "您确定要删除此工单吗？",
      "confirm-title": "删除工单"
    },
    "detail": {
      "control-card": "<Name/> 于 <Date/>",
      "message-placeholder": "输入消息...",
      "refreshed": "工单已更新",
      "status-changed": "<Name/> 将状态更改为 <Status/>",
      "title": "工单"
    },
    "edit": {
      "submit": "保存"
    },
    "filter": {
      "location": "适用于对象",
      "no-location": "无对象",
      "status": "状态",
      "text": "搜索",
      "text-placeholder": "在工单中搜索...",
      "title": "筛选"
    },
    "new": "新工单",
    "no-tickets": "未找到工单",
    "pagination-count": "{{itemCount}} 个工单",
    "status": {
      "DONE": "已完成",
      "IN_PROGRESS": "处理中",
      "TODO": "待处理"
    },
    "tab": {
      "for-me": "分配给我",
      "from-me": "由我提交"
    },
    "title": "工单"
  }
}
